import { Droplets, MapPin, Clock, Bell, Download } from 'lucide-react';
import { formatPriceWithCurrency } from '@/lib/utils';

const IMAGIN_BASE = 'https://cdn.imagin.studio/getImage?customer=wegems-supplier&paintId=pspc0004&angle=23&zoomType=fullscreen&width=400';

const plans = [
  {
    type: 'sedan',
    name: 'سيدان',
    nameEn: 'Sedan',
    price: 70000,
    maxWashes: 6,
    imageUrl: `${IMAGIN_BASE}&make=toyota&modelFamily=camry&modelYear=2024`,
  },
  {
    type: 'suv',
    name: 'دفع رباعي',
    nameEn: 'SUV',
    price: 110000,
    maxWashes: 6,
    imageUrl: `${IMAGIN_BASE}&make=toyota&modelFamily=rav4&modelYear=2024`,
  },
  {
    type: 'large_suv',
    name: 'دفع رباعي كبير',
    nameEn: 'Large SUV',
    price: 145000,
    maxWashes: 6,
    imageUrl: `${IMAGIN_BASE}&make=toyota&modelFamily=land-cruiser&modelYear=2024`,
  },
];

export default function PricingSection() {
  return (
    <section id="plans" className="py-16 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 anim-fade-up">
          <h2 className="text-2xl md:text-3xl font-bold text-text-brand font-cairo mb-2">باقات الاشتراك</h2>
          <p className="text-text-muted">السعر يتحدد تلقائياً حسب نوع سيارتك</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map((plan, i) => (
            <div
              key={plan.type}
              className={`anim-fade-up delay-${i + 1} relative overflow-hidden bg-white rounded-2xl p-6 border-2 border-gray-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group`}
            >
              {/* Gradient top bar (visible on hover) */}
              <div className="absolute top-0 right-0 left-0 h-1 bg-gradient-to-l from-primary-600 to-primary-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              <div className="text-center">
                <img
                  src={plan.imageUrl}
                  alt={plan.nameEn}
                  loading="lazy"
                  className="w-full aspect-[16/10] object-contain mx-auto mb-3"
                />
                <h3 className="text-xl font-bold text-text-brand">{plan.name}</h3>
                <p className="text-xs text-text-faint mb-4">{plan.nameEn}</p>
                <p className="text-3xl font-bold text-primary-600">
                  {formatPriceWithCurrency(plan.price)}
                </p>
                <p className="text-sm text-text-muted mt-1">شهرياً</p>
              </div>

              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-2 text-sm text-text-brand">
                  <Droplets className="w-4 h-4 text-primary-500 shrink-0" />
                  <span>حتى {plan.maxWashes} غسلات بالشهر</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-text-brand">
                  <MapPin className="w-4 h-4 text-primary-500 shrink-0" />
                  <span>في أي مغسلة شريكة</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-text-brand">
                  <Clock className="w-4 h-4 text-primary-500 shrink-0" />
                  <span>تتبع الطابور مباشرة</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-text-brand">
                  <Bell className="w-4 h-4 text-primary-500 shrink-0" />
                  <span>إشعارات فورية</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Single CTA */}
        <div className="text-center mt-10 anim-fade-up">
          <p className="text-text-muted text-sm mb-4">أدخل بيانات سيارتك في التطبيق وسيتم تحديد الباقة والسعر تلقائياً</p>
          <a
            href="#download"
            className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-medium px-8 py-3 rounded-full transition-colors"
          >
            <Download className="w-4 h-4" />
            اشترك الآن
          </a>
        </div>
      </div>
    </section>
  );
}
